import { BaseEntity } from '../base/base.entities';

// 任务执行状态
export type JobStatus = 'waiting' | 'allocated' | 'executing' | 'succeed' | 'failed';

export enum CreationToolType {
  // 概念探索
  'DraftGenerate' = 'manuscript_generation',
  // 线稿提取
  'LineExtraction' = 'line_drawing_extraction',
  // 配色参考
  'LineRefinement' = 'line_drawing_refinement',
  // 色稿细化
  'ColorRefinement' = 'color_version_refinement',
  // 成稿提质
  'Upgrade' = 'drawing_improvement',
  // 粗草细化
  'DraftRefinement' = 'draft_refinement',
  // 智能编辑
  'SmartEditor' = 'editor',
  // 智能替换
  'IntelligentReplacement' = 'intelligent_replacement',
  // 灵感生成
  'Inspiration' = 'inspiration',
  // 超分放大
  'Upscale' = 'upscale',
  // 智能替换
  'Replace' = 'replace',
  // 智能擦除
  'Remove' = 'remove',
  // 局部细化
  'Refine' = 'refine',
  // 一键抠图
  'Matting' = 'matting',
  // 图像裁切
  'Crop' = 'crop',
  // 画面拓展
  'Expand' = 'expand',
}

// 创作类型来源
export enum CreationFromType {
  COMMON = 'common',
  WORK = 'work',
  CANVAS = 'canvas',
  EDITOR = 'editor',
  INSPIRATION = 'inspiration',
}

export enum CommonFromType {
  COMMON = 'common',
}

// 类型枚举
export enum CreationTypeEnum {
  // 人物角色
  CHARACTER = 'character',
  // 道具
  PROPS = 'props',
  // 场景
  SCENE = 'scene',
}

// 风格枚举
export enum CreationStyleEnum {
  // 日系平涂
  Celluloid = 'celluloid',
  // 日系半厚涂
  FakeImpasto = 'fake_impasto',
  // 韩系半写实
  SemiRealistic = 'semi_realistic',
  // 欧美卡通
  EuramericanCartoon = 'euramerican_cartoon',
}

// 参考图类型枚举
export enum ReferenceType {
  // 创意草图
  Draft = 'DRAFT',
  // Pose 图
  Pose = 'POSE',
  // 按选区
  Selection = 'SELECTION',
}

export enum FittingSuitType {
  // 连体衣
  Bodysuit = 'bodysuit',

  // 上装
  Tops = 'tops',

  // 下装
  Lower = 'lower',
}

export enum BackgroundType {
  // 背景模板
  Template = 'TEMPLATE',

  // 自定义模板
  Custom = 'CUSTOM',

  // 参照商品图
  Image = 'IMAGE',
}

export enum DraftStyletType {
  // 模板
  Template = 'TEMPLATE',

  // 自定义
  Custom = 'CUSTOM',
}

export enum DraftStyleModel {
  Pet = 'pet',
  Portrait = 'portrait',
  View = 'view',
}

export const DraftStyleModelTitle = {
  [DraftStyleModel.Pet]: '宠物',
  [DraftStyleModel.Portrait]: '肖像',
  [DraftStyleModel.View]: '景色',
};

//草图类型枚举
export enum ReferenceDraftType {
  // 线条草图
  Line = 'scribble',
  // 色块草图
  Color = 'color_sketch',
  // 参考深度
  Depth = 'depth',
}

// 参考图来源枚举
export enum ReferenceSource {
  // 本地上传
  Upload = 'UPLOAD',
  // 灵感
  Inspiration = 'INSPIRATION',
  // 作品
  Work = 'WORK',
  // 画布
  Canvas = 'CANVAS',
}

export enum WorkSource {
  // 创作版本
  GenerateRecord = 'GenerateRecord',

  // 参考图记录
  UploadedRecord = 'UploadedRecord',

  // 我的标记
  MyMark = 'MyMark',
}

// 场景类型枚举
export enum SceneTypeEnum {
  Scenario = 'scenario',
  Standalone = 'standalone',
}

// 重绘幅度枚举
export enum RepeatStrengthEnum {
  Small = 'SMALL',
  Large = 'LARGE',
}

export enum SourceType {
  CREATE = 'CREATE',
  EDITOR = 'EDITOR',
  INSPIRATION = 'INSPIRATION',
  WORK = 'WORK',
  UPLOAD = 'UPLOAD',
  REITERATE = 'REITERATE',
  DRAFT = 'DRAFT',
}

// 提质类型枚举
export enum ImprovementTypeEnum {
  Upscale = 'UPSCALE',
  Improve = 'IMPROVE',
}

// 配色方案枚举
export enum ColorTypeEnum {
  //AI随机配色
  Random = 'color_random',
  //色调预设
  Preset = 'color_preset',
  //部位配色
  Scheme = 'color_scheme',
  //形象配色
  Image = 'color_image',
}

/**
 * 智能创作
 */
export interface Creation extends BaseEntity {
  name?: string;
  // 作品类型
  type: string;
  // 作品风格
  style: string;
  //是否Q版
  cute?: boolean;
  // 是否临时作品
  temp?: boolean;
  // 当前调试信息
  debugger?: CreationDebugger;
  // 当前执行的任务
  jobs: CreationJob[];
  // 来源图片
  image: {
    sourceId: number;
    sourceType: SourceType;
    url: string;
  };

  generateMode: number;
}

// 创建智能创作参数
export interface CreationCreateParams {
  name?: string;
  // 作品类型
  type?: string;
  // 作品风格
  style?: string;
  //是否Q版
  cute?: boolean;
  // 图片地址
  image?: {
    url?: string;
    sourceType?: string;
    sourceId?: string;
  };
  jobs?: object;
}

// 创建公共智能创作参数
export interface CreationCommonCreateParams {
  name?: string;
  // 作品类型
  type?: string;
  // 作品风格
  style?: string;
  //是否Q版
  cute?: boolean;
  // 图片地址
  image?: {
    url?: string;
    sourceType?: string;
    sourceId?: string;
  };
  jobs?: object;
}

// 智能创作精简信息（列表展示）
export interface CreationSimple extends BaseEntity {
  // 作品类型
  type: string;
  // 作品风格
  style: string;
  //是否Q版
  cute?: boolean;
  creationType: string;
  name: string;
  url: string;
  height: number;
  width: number;
}

// 细化参数
export interface CreationParamsInfo {
  categories?: string;
  param: string;
  paramText: string;
}

// 我的参数
export interface CreationMyParamsInfo {
  id: number;
  noCn: string;
  noEn: string;
  promptsCn: string;
  promptsEn: string;
  params: CreationParamsInfo[];
}

export interface ColorDebugger {
  colors: string[];
  parts: {
    type: string;
    values: {
      color: string;
      part: string;
    }[];
  };
  reference: {
    intensity: string;
    url: string;
  };
  type: string;
}

export interface CreationDebuggerImage {
  //参考图ID
  id?: number;
  // 强度
  intensity?: number;
  // 地址
  url?: string;
  // 类型
  type: ReferenceType;
  // 草图类型
  draftType?: ReferenceDraftType;
  // 来源id
  sourceId: string;
  // 来源类型 INSPIRATION,WORK
  sourceType: ReferenceSource;
}

// 调试参数
export interface CreationDebugger {
  version: number;
  color: ColorDebugger;
  display: {
    ar?: number;
    resolution?: string;
    simpleBackground?: boolean;
  };
  // 垫图
  image?: CreationDebuggerImage;
  mask?: {
    full?: boolean;
    url?: string;
  };
  reference?: {
    draftType?: string;
    intensity?: number;
    sourceId?: number;
    sourceType?: string;
    type?: string;
    url?: string;
  };
  // 是否开启面部精修
  faceInpaint: boolean;
  // 提示词
  prompt?: {
    // 权重
    intensity?: number;
    // 负向中文提示词
    negPromptsCn?: string;
    // 负向英文提示词
    negPromptsEn?: string;
    // 中文提示词
    promptsCn?: string;
    // 英文提示词
    promptsEn?: string;
  };
  // 场景类型,可用值:scenario,standalone
  sceneType: SceneTypeEnum;
  // 我的参数
  myParams?: CreationMyParamsInfo[];
  // 细化参数
  params?: Array<CreationParamsInfo>;
  //重绘幅度
  repeat?: {
    //次数
    num?: number;
    //幅度
    strength?: RepeatStrengthEnum;
    //程度
    degree?: number;
    //组合
    all?: boolean;
    //是否再迭代
    reiterate?: boolean;
    // 参考图
    image?: {
      //文件ID
      sourceId?: string;
      //文件地址
      url?: string;
    };
  };
  //画面提质
  improvement?: {
    //类型
    type: ImprovementTypeEnum;
    //放大倍数
    upscale: number;
    //画面降噪
    denoise: boolean;
  };
  // 形象参考
  imagePrompt?: {
    images?: Array<CreationDebuggerImage>;
    urls: Array<CreationDebuggerImage>;
    weight: number;
  };
  meta?: any;
}

// 提交生成任务信息
export interface CreationWorkInfo {
  // 能力阶段
  ability: CreationToolType;
  debugger: CreationDebugger;
  num: number;
}

// 作品版本记录
export interface CreationWorkVersion extends BaseEntity {
  // 能力阶段
  ability: CreationToolType;

  // 风格
  style: string;
  // 类型
  type: string;
  files: CreationFileInfo[];
  // 调试信息
  debugger: CreationDebugger;
  // 任务状态
  status?: string;
  // 来源
  versionType: string;
}

// 作图任务信息
export interface CreationJob extends BaseEntity {
  // 能力阶段
  ability: CreationToolType;
  // 调试信息
  debugger?: CreationDebugger;
  // 错误日志
  errorMsg?: string;
  // 出图数量
  num?: number;
  // 状态
  status: JobStatus;
  // 生成作品文件
  files?: CreationFileInfo[];
  // 来源
  versionType?: string;
  // 任务等待数
  waitingNum?: number;
}

// 作品文件信息
export interface CreationFileInfo extends BaseEntity {
  ar: number;
  id: string;
  url: string;
  height: number;
  width: number;
  size: number;
  mark?: boolean;
  contentType?: string;
  sourceType?: string;
  debugger?: CreationDebugger;
}

// 作品文件详细信息
export interface CreationFileDetailInfo extends CreationFileInfo {
  // 能力阶段
  ability: CreationToolType;
  // 内容来源 CREATE:创建  UPLOAD:上传
  contentType: 'CREATE' | 'UPLOAD' | 'REFERENCE';
  debugger: CreationDebugger;
  ar: number;
  url: string;
  height: number;
  width: number;
  size: number;
  style: string;
  type: string;
  cute: boolean;
  // 版本来源 CREATE = '直接生成' EDITOR = '智能编辑'
  sourceType: SourceType;
  otherWork: boolean;
}

export interface DraftsRes {
  createBy: string;
  createTime: Record<string, unknown>;
  design: Record<string, unknown>;
  id: number;
  image: {
    height: number;
    size: number;
    url: string;
    width: number;
  };
  modifyBy: string;
  modifyTime: Record<string, unknown>;
}

// 响应接口
export interface CreationRecommend {
  code: string;
  createBy: string;
  createTime: Record<string, unknown>;
  cute: number;
  id: number;
  images: Record<string, unknown>;
  modifyBy: string;
  modifyTime: Record<string, unknown>;
  name: string;
  status: string;
  subject: string;
  technique: string;
  types: Record<string, unknown>[];
}

export interface CaptionRes {
  code: number;
  doing: boolean;
  message: string;
  promptCn: string;
  promptEn: string;
  responseBody: string;
  status: string;
  succeed: boolean;
}

export interface MockupTemplate {
  id: number;
  meta: object;
  preview: string;
  title: string;
  type: string;
}
